import {useMutation, useQuery} from '@apollo/react-hooks';
import {get} from 'lodash';
import getCompletedLessons from '../api/getCompletedLessons.query';
import upsertBatchUserData from '../api/upsertBatchUserData.mutation';

export default (productID) => {
    const { data, loading, error } = useQuery(getCompletedLessons, {
        variables: {
            productID,
        },
        skip: !productID,
    });
    const [batchCompleteLessonsMutation] = useMutation(upsertBatchUserData);

    /* Lesson completion array = [
           {
            lessonId: 2,
            completed: true
           }
     ]
     */
    const batchCompleteLessons = async (lessonCompletionArray) => batchCompleteLessonsMutation({
        variables: {
            productId: productID,
            body: JSON.stringify(lessonCompletionArray.map(({ lessonID, completed }) => ({
                type: 'completedLesson',
                type_id: lessonID,
                data: { completed },
            }))),
        },
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: getCompletedLessons,
                variables: { productID },
            },
        ],
    });

    const completeLesson = async (lessonID, completed = true) => batchCompleteLessons([{
        lessonID,
        completed,
    }]);


    if (error) {
        console.log('Error', error);
    }

    const completedLessons = get(data, 'getCompletedLessons.data', [])
        .map(({ type_id: id, data: userData }) => ({
            id,
            data: JSON.parse(userData),
        }))
        .filter(({ data: userData }) => !!get(userData, 'completed'));


    return {
        loading,
        completeLesson,
        batchCompleteLessons,
        data: completedLessons,
        totalCompletedLessons: completedLessons.length,
    };
};
